// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/$location._c.users/route.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/$location._c.users/route.tsx");
}
// REMIX HMR END

import { userSummaryListExample } from '@commural/shared-resources/schemas/business/User.example';
import { useLoaderDataWithCache } from '@commural/shared-resources/utils/common';
import { Link } from '@remix-run/react';
import { DateTime } from 'luxon';
import { useCallback, useMemo } from 'react';
import invariant from 'tiny-invariant';
import { Pagination } from '~/components/Pagination';
import { ScrollView } from '~/components/ScrollView';
import { getCapitalized } from '~/utils.server';
import cn from './Users.module.css';
const TITLE = 'user list';
export async function loader({
  request,
  context
}) {
  const title = await getCapitalized(TITLE, request, context);
  const url = new URL(request.url);
  const currentPage = +(url.searchParams.get('page') ?? '1');
  const userSummaryList = userSummaryListExample;
  const count = userSummaryList.length;
  const pageSize = 7;
  const pageCount = Math.ceil(count / pageSize);
  const start = (currentPage - 1) * pageSize;
  const end = start + pageSize;
  const selectedUserSummaryList = userSummaryList.slice(start, end);
  return {
    title,
    userSummaryList: selectedUserSummaryList,
    currentPage,
    pageCount
  };
}
export const meta = ({
  data
}) => {
  invariant(data?.title, 'title is required');
  return [{
    title: data.title
  }];
};
export const handle = {
  title: TITLE
};
export default function Index() {
  _s();
  const {
    userSummaryList,
    currentPage,
    pageCount
  } = useLoaderDataWithCache();
  return <ScrollView>
      <section className={cn.Users}>
        <header className={cn.Header}>
          <div>
            <button className="debug-block">manage group</button>
            <button className="debug-block">send coupon</button>
            <button className="debug-block">send questionnaire</button>
            <button className="debug-block">send event</button>
          </div>
          <div>
            <button className="debug-block">filter</button>
            <input placeholder="date range" className="debug-block" />
            <input placeholder="search" className="debug-block" />
          </div>
        </header>
        <main>
          <table>
            <thead>
              <tr>
                <th>
                  <input type="checkbox" />
                </th>
                <th>User name</th>
                <th>Role</th>
                <th>Last login</th>
              </tr>
            </thead>
            <tbody>
              {userSummaryList.map(el => <UserSummaryListItem key={el.id} userSummary={el} checked={false} onChange={() => {}} />)}
            </tbody>
          </table>
        </main>
        <footer className={cn.Footer}>
          <Pagination currentPage={currentPage} pageCount={pageCount} />
        </footer>
      </section>
    </ScrollView>;
}
_s(Index, "+uWvqNgkSdnCoJehiwUme5Te1Mg=", false, function () {
  return [useLoaderDataWithCache];
});
_c = Index;
function UserSummaryListItem({
  userSummary,
  checked,
  onChange
}) {
  _s2();
  const {
    id,
    name,
    role,
    lastLoginAt
  } = userSummary;
  const lastLoginAtFormatted = useMemo(() => DateTime.fromISO(lastLoginAt, {
    setZone: true
  }).toLocaleString(DateTime.DATETIME_SHORT), [lastLoginAt]);
  const handleChange = useCallback(e => {
    onChange(e.target.checked);
  }, [onChange]);
  return <tr>
      <td>
        <input type="checkbox" checked={checked} onChange={handleChange} />
      </td>
      <td>
        <Link to={id}>{name}</Link>
      </td>
      <td>{role}</td>
      <td>{lastLoginAtFormatted}</td>
    </tr>;
}
_s2(UserSummaryListItem, "dVto802Oy67jOCtUbMlDN2ecDEI=");
_c2 = UserSummaryListItem;
var _c, _c2;
$RefreshReg$(_c, "Index");
$RefreshReg$(_c2, "UserSummaryListItem");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;